import { render, staticRenderFns } from "./CustomerBlock.vue?vue&type=template&id=335ecdc3&scoped=true"
import script from "./CustomerBlock.vue?vue&type=script&lang=js"
export * from "./CustomerBlock.vue?vue&type=script&lang=js"
import style0 from "./CustomerBlock.vue?vue&type=style&index=0&id=335ecdc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335ecdc3",
  null
  
)

export default component.exports